import { ISchool } from '../interfaces/school.interface'
import {
  createTheme,
  Theme,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material/styles'
import theme from '../src/theme'
import React from 'react'

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

export default function SchoolMaterialThemeContainer(props: {
  schoolDetails: ISchool
  children: React.ReactChild
}) {
  const color_scheme = { ...props.schoolDetails?.color_scheme }
  const _theme = { ...theme }
  _theme.palette.primary.main =
    color_scheme.primary || theme.palette.primary.main
  _theme.palette.secondary.main =
    color_scheme.secondary || theme.palette.secondary.main

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={createTheme(_theme)}>
        {props.children}
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
